// extracted by mini-css-extract-plugin
export default {"success":"SLOcT01Oo93011oF46lo2w==","successIcon":"VFTGt8f8RvnQqXSzzIdMUQ==","priceCta":"jeQrgMxjlSSRTWCI7DH2UQ=="};